export const fetchNotifs = (resp) => ({
  type: "FETCH_NOTIFS",
  payload: resp,
});
